import { IObjectRepresentingCalendarDay } from "./commons.interface";

type IWorkerOrDriver =
  | { VehicleId: number; WorkerId?: never }
  | { VehicleId?: never; WorkerId: number };

export type IGetTachographDataRequest = {
    DateFrom: string;
    DateTo: string;
    UtcOffsetMinutes: number;
} & IWorkerOrDriver;

export interface ITachographDayData {
  Day: IObjectRepresentingCalendarDay;
  Date: string;
  TotalRestMinutes: number;
  TotalReadyMinutes: number;
  TotalWorkMinutes: number;
  TotalDriveMinutes: number;
  Segments: ITachographDaySegment[];
}

export interface ITachographDaySegment {
  To: string;
  From: string;
  State: TachoWorkState;
}

export enum TachoWorkState {
  None = -1,
  Rest = 0,
  Ready = 1,
  Work = 2,
  Drive = 3,
}

export interface ISetTachographConfig {
  DriverCardReadDaysInterval: number;
  TachographMemoryReadDaysInterval: number;
}

export interface IGetTachographConfigResponse {
  DriverCardReadDaysInterval: number;
  TachographMemoryReadDaysInterval: number;
}
